import React from 'react';
import PropTypes from 'prop-types';
import { MyPureComponent } from '../../lib/react';

class Aspect extends MyPureComponent {
  static propTypes = {
    ratio: PropTypes.number,
  };
  static defaultProps = {
    ratio: 1,
  };

  render() {
    const { ratio, children, ...otherProps } = this.props;
    const outerStyle = {
      position: 'relative',
      width: '100%',
      paddingTop: `${ratio * 100}%`,
      height: 0,
      maxHeight: 0,
    };
    const innerStyle = {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    };

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, otherProps),
    );

    return (
      <div style={outerStyle}>
        <div style={innerStyle}>{childrenWithProps}</div>
      </div>
    );
  }
}

export default Aspect;



// WEBPACK FOOTER //
// ./src/components/Aspect/Aspect.js